import { Action } from "../../../actions/actions";
import { AuthActionTypes } from "../actions/actionTypes";

const initialState: boolean = false;

export function submittingNewPasswordReducer(state = initialState, action: Action) {
    switch (action.type) {
        case AuthActionTypes.NEW_PASSWORD:
            return !state;
        case AuthActionTypes.NEW_PASSWORD_SUCCESS:
        case AuthActionTypes.NEW_PASSWORD_FAIL:
            return !state;
        default:
            return state;
    }
}
